export const AuctionStatusType = {
  PHYSICAL: 'PHYSICAL',
  MINIMUM_PRICE: 'MINIMUM_PRICE',
  TRYING_TO_DEAL: 'TRYING_TO_DEAL',
};

export const AuctionStatusTypeName = {
  TRYING_TO_DEAL: 'Trying to Deal',
  MINIMUM_PRICE: 'No Reserve',
  PHYSICAL: 'Physical Vehicle',
};

export const AvailableAuctionStatuses = [
  AuctionStatusType.MINIMUM_PRICE,
  AuctionStatusType.PHYSICAL,
];
